import bg from '../assets/bg.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import roll from '../assets/roll.svg';
import welcome from '../assets/welcome.png';
import navlogo from '../assets/navlogo.png';
import app1 from '../assets/app1.png';
import app2 from '../assets/app2.png';
import app3 from '../assets/app3.png';

const images = {
  bg,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  menu,
  overlaybg,
  roll,
  welcome,
  navlogo,
  app1,
  app2,
  app3,
};

export default images;